<template>
  <div class="container">
    <div class="cam relative">
      <div class="cover" v-if="loading">
        <p class="text-light text-center mt-3">Iniciando cámara...</p>
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
      <web-cam
        ref="webcam"
        :device-id="deviceId"
        width="100%"
        height="100%"
        @error="onError"
        @cameras="onCameras"
        @started="onStarted"
        v-show="!img"
      />
      <div
        class="
          d-flex
          justify-content-center
          flex-wrap
          align-items-center
          cam__button__container
        "
        v-if="!img"
      >
        <button class="btn btn-rounded btn-takeSnap" @click="onCapture">
          <i class="fas fa-camera"></i>
        </button>
        <div class="pl-2">
          <button
            class="btn btn-rounded btn-switchCam"
            @click="toggleCam"
            v-if="isMobile"
          >
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 p-0 text-center result__container" v-if="img">
      <img :src="img" />
    </div>

    <select v-model="camera" v-if="devices.length > 2">
      <option>-- Selecciona tu cámara --</option>
      <option
        v-for="device in devices"
        :key="device.deviceId"
        :value="device.deviceId"
      >
        {{ device.label }}
      </option>
    </select>

    <div class="d-flex justify-content-end" v-if="false">
      <button type="button" class="btn btn-danger mr-1" @click="onStop">
        Detener cámara
      </button>
      <button type="button" class="btn btn-success" @click="onStart">
        {{ img ? "Tomar otra" : "Iniciar cámara" }}
      </button>
    </div>
  </div>
</template>

<script>
import { WebCam } from "vue-web-cam";
import { device } from "../../assets/helpers";

export default {
  name: "Photo",
  components: {
    WebCam,
  },
  data() {
    return {
      loading: true,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
    };
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      let first = this.devices;

      if (first.length > 1) {
        this.camera = first[1].deviceId;
        this.deviceId = first[1].deviceId;
      } else {
        this.camera = first[0].deviceId;
        this.deviceId = first[0].deviceId;
      }
    },
  },
  methods: {
    onCapture() {
      this.img = this.$refs.webcam.capture();
      this.$emit("shot", this.img);
      this.onStop();
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.img = null;
      this.loading = true;
      this.$refs.webcam.start();
    },
    onError(error) {
      alert("Lo sentimos, no podemos acceder a tu cámara");
    },
    onCameras(cameras) {
      this.devices = cameras;
    },
    onStarted() {
      this.loading = false;
    },
    toggleCam() {
      if (this.devices.length === 2) {
        const firstID = this.devices[0];

        if (firstID.deviceId == this.deviceId) {
          this.deviceId = this.devices[1].deviceId;
        } else {
          this.deviceId = this.devices[0].deviceId;
        }
      }
    },
  },
  computed: {
    isMobile() {
      return device.isMobile();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cam__button__container {
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  position: absolute;
  left: 0;
  bottom: 5px;
  width: 100%;
  padding: 5px 0;
}
.btn-rounded {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  color: white;
  text-align: center;
}
.btn-takeSnap {
  background-color: #003c71;
  border: 1px solid rgba(255, 255, 255, 0.596);
  width: 40px;
  height: 40px;
}
.btn-switchCam {
  padding-top: 4px;
  padding-left: 0;
  padding-right: 0;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.596);
}

.result__container {
  img {
    width: 100%;
    height: auto;
  }
}

// Spinner and cover
.cover {
  position: absolute;
  z-index: 5;
  left: 0;
  top: 0;
  background-color: #003c71;
  width: 100%;
  height: 100%;
}
.spinner {
  width: 40px;
  height: 40px;

  position: relative;
  margin: 100px auto;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgb(233, 233, 233);
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>